import { selectClient } from "services/client";
import { type State } from "types";

export const selectClientLanguageCode = (state: State) =>
  selectClient(state)?.language;
